import LoanCreate from './LoanCreate';

export default LoanCreate;
